/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import FormControlLabel from '@material-ui/core/FormControlLabel';

import React from 'react';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import {
  getRebateProgrameList,
  getPlanTypeValues,
  getInvoiceRegisterMaxQtr,
  getInvoiceResultUnchecked,
  getInvoiceResult,
  setInvoiceRegisterChecked,
  setInvoiceRegisterUnchecked,
  setSearchInput,
  refreshInvoiceRegister,
  dispatchNoDataMessage,
} from '../Store/action';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  convertToFourDigitYear,
  tabHighLigther,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';
import { REBATE_SELECT } from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';


export default function InvoiceRegister(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    invoiceOption: invoiceOptionValue,
    formerRetains: formerRetainsValue,

    zeroUraMaxQuarter,
    quarterValue,
    invoiceHandle: invoiceHandleValue,
    invoiceResult,
    invoiceResultUnchecked,
  } = useSelector((state) => state?.sharedState?.InvoiceRegisterReducer);
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const searchScreenObj = useSelector(
    (state) => state?.sharedState?.InvoiceRegisterReducer?.searchScreenRedux
  );
  const noDataMessage = useSelector(
    (state) => state?.sharedState?.InvoiceRegisterReducer?.noDataMessage
  );
  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(
    searchScreenObj?.rebateProgramValue || rebateProgramValue
  );
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );

  const [invoiceOption, setInvoiceOption] = React.useState(
    searchScreenObj?.invoiceOption
  );
  const [confirmAction, setConfirmAction] = React.useState(false);


  const [errorList, setErrorList] = React.useState(errors);
  const [invoiceHandle, setInvoiceHandle] = React.useState(
    searchScreenObj?.invoiceHandle || invoiceHandleValue
  );
  const [quarter, setQuarter] = React.useState(
    searchScreenObj?.quarterValue || quarterValue
  );
  const [formerRetains, setFormerRetains] = React.useState(
    searchScreenObj?.formerRetains
  );
  const [isSearchClicked, setSearchClicked] = React.useState(false);

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  React.useEffect(() => {
    if (noDataMessage) {
      setErrorMessage([noDataMessage]);
    } else {
      setErrorMessage([]);
    }
  }, [noDataMessage]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    if (!quarter)
      dispatch(
        getInvoiceRegisterMaxQtr({
          rebateProgramCd: tempRebateProgram.rebateProgramCd,
        })
      );
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // React.useEffect(() => {
  //   dispatch(getInvoiceRegisterMaxQtr());
  // }, []);

  // To set the quarter varaible
  React.useEffect(() => {
    if (zeroUraMaxQuarter && searchScreenObj?.quarterValue === '') {
      setQuarter(quarterValue || zeroUraMaxQuarter);
      dispatch(
        refreshInvoiceRegister({
          ...searchScreenObj,
          quarterValue: quarterValue || zeroUraMaxQuarter,
        })
      );
      // setQuarter(zeroUraMaxQuarter);
    }
  }, [zeroUraMaxQuarter]);

  

  const handler = (name, checked) => {
    setInvoiceHandle((prev) => {
      const updated = {
        ...prev,
        [name]: checked,
      };
  
      dispatch(
        refreshInvoiceRegister({
          ...searchScreenObj,
          invoiceHandle: updated,
        })
      );
  
      return updated;
    });
  };
  

  // function to conver 2 digit year to 4 digit ear
  const convertTo4DigitQtr = (value) => {
    const tempValue = value?.split('Q');

    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue?.join('Q');
  };

  // Handle onblur events for date and quarter
  const handleOnBlur = (type, value) => {
    let localErrors = errorList;
    if (type === 'qtr') {
      localErrors = localErrors.filter((error) => error.field != 'qtr');
      const qtrErr = validateQuarter(value, 'qtr', true);
      if (qtrErr.length === 0) {
        const qtr = value.length == 4 ? convertTo4DigitQtr(value) : value;
        setQuarter(qtr);
        dispatch(
          refreshInvoiceRegister({
            ...searchScreenObj,
            quarterValue: qtr,
          })
        );
      } else {
        localErrors = [...localErrors, ...qtrErr];
      }
    }
    setErrorList(localErrors);
  };

  let selectedQtr = quarter?.split('Q');
  selectedQtr = selectedQtr[1] + selectedQtr[0];

  let selectedInvoice = [];
  if (invoiceHandle.None) {
    selectedInvoice = selectedInvoice.concat('N');
  }
  if (invoiceHandle.Forgiven) {
    selectedInvoice = selectedInvoice.concat('F');
  }
  if (invoiceHandle.Mailed) {
    selectedInvoice = selectedInvoice.concat('M');
  }
  if (invoiceHandle.Retained) {
    selectedInvoice = selectedInvoice.concat('R');
  }

  const handleSearchClick = () => {
    //dispatch(dispatchNoDataMessage([]));
    const isAllUnchecked =
    !invoiceHandle?.None &&
    !invoiceHandle?.Mailed &&
    !invoiceHandle?.Forgiven &&
    !invoiceHandle?.Retained;
    if(isAllUnchecked==true){
      setConfirmAction(isAllUnchecked);
      return;
    }
    let allErrors = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    // if (invoiceHandle.Forgiven === false) {
    //   allErrors.push({
    //     // field: 'rebateProgram',
    //     message: 'Invoice Handling is Required',
    //   });
    // }
    allErrors = [...allErrors, ...errorList];
    setErrorList(allErrors);
    if (allErrors.length === 0) {
      dispatch(setInvoiceRegisterChecked([]));
      dispatch(setInvoiceRegisterUnchecked([]));
      setSearchClicked(true);
      let rebateProgrameName =
        selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
      rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${rebateProgrameName?.shortDescr || ''
        }`;
      const searchInputData = {
        [rebateProgram]: {
          selectedPlanType: planType,
          rebateProgramValue: rebateProgram,
          rebateProgramName,
          quarterValue: quarter,
          formerRetains,
          invoiceHandle,
          invoiceOption,
          rebateProgrameName,
          displayObj: {
            rebateProgramValue: rebateProgram,
            rebateProgramList: rebateProgramListData,
            quarterValue: quarter,
            formerRetains,
            invoiceHandle,
            invoiceOption,
            rebateProgrameName,
          },
        },
      };
      dispatch(
        refreshInvoiceRegister({
          ...searchScreenObj,
          rebateProgramValue: rebateProgram,
          rebateProgramList: rebateProgramListData,
          quarterValue: quarter,
          invoiceHandle: searchScreenObj?.invoiceHandle,
        })
      );
      dispatch(setSearchInput(searchInputData));
      if (formerRetains) {
        dispatch(
          getInvoiceResult({
            rebateProgramCd: rebateProgram,
            retainPrintQtr: quarter,
            invoiceHandlingCd: selectedInvoice,
            as_null: invoiceHandle?.None ? '0' : '1',
            frozen: invoiceOption,
          })
        );
      } else {
        dispatch(
          getInvoiceResultUnchecked({
            rebateProgramCd: rebateProgram,
            retainPrintQtr: quarter,
            invoiceHandlingCd: selectedInvoice,
            as_null: invoiceHandle?.None ? '0' : '1',
            frozen: invoiceOption,
          })
        );
      }
    }
  };
  if (
    (isSearchClicked && invoiceResult) ||
    (isSearchClicked && invoiceResultUnchecked)
  ) {
    const invoiceResultObj = invoiceResult?.find((obj) => {
      return obj[rebateProgram];
    });
    const invoiceResultUncheckedObj = invoiceResultUnchecked?.find((obj) => {
      return obj[rebateProgram];
    });
    if (
      (isSearchClicked &&
        invoiceResultObj &&
        invoiceResultObj[rebateProgram] &&
        invoiceResultObj[rebateProgram].length > 0) ||
      (isSearchClicked &&
        invoiceResultUncheckedObj &&
        invoiceResultUncheckedObj[rebateProgram] &&
        invoiceResultUnchecked.length > 0)
    ) {
      setSearchClicked(false);
      const navTo = `/invoice/${rebateProgram}`;
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: navTo,
        value: `Display Invoice Register Summary Rpt [${rebateProgram}]`,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props.history.push({
        pathname: navTo,
      });
      dispatch(clearReduxForFilterAndSort(navTo));
    }
  }
  // handing highlight tab
  React.useEffect(() => {
    if (errorList?.length > 0) {
      tabHighLigther('/invoiceRegister', true);
    } else {
      tabHighLigther('/invoiceRegister', false);
    }
  }, [JSON.stringify(errorList)]);
                
  // remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [ planType, planTypeList, invoiceOption, rebateProgram, quarter, invoiceHandle]);
  
  const errorMessages = [...new Set(errorList?.map((obj) => obj.message))];
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator parent1="Summary Reports" parent2="Invoice Register" />
      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      {errorMessage.length != 0 ? (
        <DisplayErrorMessages errorMessages={errorMessage} />
      ) : null}
      <div className="tab-body">
        <div className="row mb-3">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="req-inv-reg-fltr-plantype"
              id="filter-plan-by-radio-btn-action"
              labelName="Plan Type"
              required
              optionList={radioList || []}
              defaultValue={planType}
              filterAction={(value) => {
                setPlanType(value);
                setRebateProgram('-1');
                const errors = errorList.filter(
                  (error) => error.field !== 'rebateProgram'
                );
                setErrorList([...errors]);
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-5 frr-three-col-radio">
            <RadioGroupComponent
              data-testid="req-inv-reg-fltr-invopt"
              id="filter-plan-by-radio-btn-action"
              labelName="Invoice Options"
              required
              optionList={[
                { name: 'Only Frozen', value: '1' },
                { name: 'Only Unfrozen', value: '2' },
                { name: 'All', value: '3' },
              ]}
              defaultValue={invoiceOption}
              filterAction={(value) => {
                setInvoiceOption(value);
                dispatch(
                  refreshInvoiceRegister({
                    ...searchScreenObj,
                    invoiceOption: value,
                  })
                );
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-3">
            <>
              <Fieldset label="Rebate Program" required>
                <div>
                  <SelectBoxComponent
                    data-testid="req-inv-reg-fltr-rbt"
                    id="filter-plan-by-radio-btn-action"
                    labelName="Rebate Program"
                    required
                    select
                    selectOne
                    optionList={selectList || []}
                    defaultValue={rebateProgram}
                    filterAction={(value) => {
                      dispatch(dispatchNoDataMessage());
                      setRebateProgram(value);
                      setRebateProgramName(value);
                      dispatch(
                        refreshInvoiceRegister({
                          ...searchScreenObj,
                          rebateProgramValue: value,
                        })
                      );
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'rebateProgram')
                        ?.message
                    }
                  />
                </div>
              </Fieldset>
            </>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Invoice Handling Codes to Display{' '}
                <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="filter-checkbox">
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      onChange={(e) => handler(e.target.name, e.target.checked)}
                      checked={invoiceHandle.None}
                      name="None"
                    />
                  }
                  label="None"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      onChange={(e) => handler(e.target.name, e.target.checked)}
                      checked={invoiceHandle.Mailed}
                      name="Mailed"
                    />
                  }
                  label="Mailed"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={invoiceHandle.Forgiven}
                      name="Forgiven"
                      onChange={(e) => handler(e.target.name, e.target.checked)}
                    />
                  }
                  label="Forgiven"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={invoiceHandle.Retained}
                      name="Retained"
                      onChange={(e) => handler(e.target.name, e.target.checked)}
                    />
                  }
                  label="Retained"
                />
              </div>
            </fieldset>
          </div>
          <div className="col-3">
            <div className="mui-custom-form input-md field-xl">
              <TextField
                label="Quarter"
                id="Quarter"
                data-testid="req-inv-reg-qtr"
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ maxLength: 6 }}
                required
                name="qtr"
                value={quarter}
                error={
                  errorList.filter((error) => error.field === 'qtr')?.length > 0
                    ? 'mandate-fields'
                    : ''
                }
                helperText={
                  errorList.find((error) => error.field === 'qtr')?.message
                }
                className="mandate-fields"
                onBlur={(e) => handleOnBlur('qtr', e.target.value)}
                onChange={(e) => {
                  dispatch(dispatchNoDataMessage());
                  const { value } = e.target;
                  setQuarter(value.toUpperCase());
                  const localErrors = errorList.filter(
                    (error) => error.field != 'qtr'
                  );
                  setErrorList(localErrors);
                }}
              />
            </div>
          </div>
          <div className="col-3 mt-4">
            <FormControlLabel
              control={
                <Checkbox
                  checked={formerRetains}
                  color="primary"
                  name="allManufacturers"
                  onChange={(e) => {
                    setFormerRetains(!formerRetains);
                    dispatch(
                      refreshInvoiceRegister({
                        ...searchScreenObj,
                        formerRetains: !formerRetains,
                      })
                    );
                  }}
                />
              }
              label="Include Former Retains"
            />
          </div>
        </div>
        <CommonModal
          open={confirmAction}
          viewAction
          className="dialog-420"
          viewHeader
          onOk={() => {
            setConfirmAction(false);
          }}
          okTitle="Ok"
          onClose={() => setConfirmAction(false)}
          modalTitle="Confirmation Dialog"
          childrenComponent={
            <div className="p-3">
              <p>
                Please select atleast 1 Handling code option
              </p>
            </div>
          }
        />

        <div className="float-right mt-2 hide-on-print" tabIndex={0}>
          <Button
            className="btn-success same-font-family"
            onClick={handleSearchClick}
          >
            <SVGComponent iconName="Icon-search" /> {' Search'}
          </Button>
        </div>
      </div>
    </div>
  );
}
